import "./util/shims.js";
import "expo-router/entry";
